import React from 'react';

export const WORDS_PER_MINUTE = 200;

// Thin-space-wrapped fish codenames so the emoji doesn't crowd adjacent CJK glyphs.
const F = '\u2009\uD83D\uDC1F\u2009'; // bare-name 渝 mentions
const FULL = '\u2009\uD83D\uDC1F\u2009'; // full-name 费渝 mentions

export const extractText = (node) => {
  if (node == null || typeof node === 'boolean') return '';
  if (typeof node === 'string' || typeof node === 'number') return String(node);
  if (Array.isArray(node)) return node.map(extractText).join(' ');
  if (React.isValidElement(node)) return extractText(node.props.children);
  if (typeof node === 'object' && node.quote) {
    return [node.quote, node.author].filter(Boolean).join(' ');
  }
  return '';
};

export const countWords = (content) => {
  const text = extractText(content);
  return text.trim().split(/\s+/).filter(Boolean).length;
};

export const formatDate = (iso) => {
  if (!iso) return '';
  const [y, m, d] = iso.split('-');
  return `${m}-${d}-${y}`;
};

const rawNotes = [
  {
    id: 'prince',
    aliases: ['chicken-frog-jump'],
    date: '2026-07-27',
    tags: ['story'],
    title: '[Memory Snapshot #05] 鸡飞蛙跳',
    excerpt: '“鸡飞狗跳，这饭店名字怎么那么奇葩？” 我刚上车，坐在副驾驶位置上，打开微信在我们三个的微信群里找饭店地址。',
    content: [
      <p className="note-content">“鸡飞狗跳，这饭店名字怎么那么奇葩？”</p>,
      <p className="note-content">我刚上车，坐在副驾驶位置上，打开微信在我们三个的微信群里找饭店地址。</p>,
      <p className="note-content">“是鸡飞蛙跳，不要念错人家饭店名字。”</p>,
      <p className="note-content">{`${F}老干部似的纠正我。`}</p>,
      <p className="note-content">“哦哦，鸡飞蛙跳，不好意思hhh”</p>,
      <p className="note-content">🐔飞🐸跳还不如鸡飞狗跳呢，我心里想。好歹我们不吃🐶肉。</p>,
      <p className="note-content">{`小鹤弟交流即将到期，回国之前我提议一起吃个饭，在我家煮火锅的建议被${FULL}一票否决，理由是太麻烦了。我和小鹤只好任由他安排。在尔湾，谁有车谁有出门决定权。`}</p>,
      <p className="note-content">接上小鹤之后，车里：</p>,
      <p className="note-content">小鹤：“姐，我看你在群里说你不吃肉，你为啥不吃肉啊？”</p>,
      <p className="note-content">我：“受我npy影响，她不吃，跟她在一起，就慢慢的也不吃了。”</p>,
      <p className="note-content">{`“女朋友？” 开车的${F}和坐后排的小鹤不约而同的好奇起来。`}</p>,
      <p className="note-content">小鹤：“啊，姐，你是lesbian啊，没看出来啊！你之前谈过很多吗？都是和女生在一起的嘛？”</p>,
      <p className="note-content">我：“昂，我和她在一起快6年了。”</p>,
      <p className="note-content">我：“我这人比较长情，只谈过3任，前面两个都是男的，只有现在这个是女的。”</p>,
      <p className="note-content">{`讲到“男的”这两个字，我故意提高声音，侧头看了看开车的${F}。`}</p>,
      <p className="note-content">{`${F}：“都谈了多久呢？”`}</p>,
      <p className="note-content">相识没多久，见面次数也屈指可数，但我们可算是聊到了感情话题。</p>,
      <p className="note-content">我：“这个是最长的，之前还有一段5年的。”</p>,
      <p className="note-content">很多年来我也不确定自己到底还喜不喜欢男的，但在那一刻我特别想让他知道我曾经是喜欢过男生的。</p>,
      <p className="note-content">{`${F}：“5年，6年，你这恋爱谈的很早。”`}</p>,
      <p className="note-content">我：“嗯，高中早恋嘛。” 我尴尬的笑了笑。</p>,
      <p className="note-content">小鹤：“那你女朋友为啥不吃肉？”</p>,
      <p className="note-content">{`${F}：“欧洲很多素食主义者。”`}</p>,
      <p className="note-content">我：“是的，而且她是严格素食主义。素食主义有很多原因吧，有伦理方面的，有从环境角度考虑的。她算是伦理加环境吧。”</p>,
      <p className="note-content">“你就这样想，阿尔卑斯山上的奶牛多可爱鲜活，看多了，再见到超市里或者市场上的血渍吧啦的肉，心里多少会有点难受。” 我继续说。</p>,
      <p className="note-content">我只是在代入自己的想象，她对奶牛的感情有多深我无从可知，但我们柏林家里的那几个server的优先级一定排在我前头。</p>,
      <p className="note-content">{`${F}：“阿尔卑斯山的奶牛，笑死。”`}</p>,
      <p className="note-content">我：“我也不是不吃肉，天上飞的和地上跑的不吃。”</p>,
      <p className="note-content">我侧过脸对着他强调，“但水里游的可以吃。”</p>,
      <p className="note-content">小鹤：“那牛蛙你吃吗？”</p>,
      <p className="note-content">我：“水陆两栖的，边界比较模糊，我能将就吃。”</p>,
      <p className="note-content">{`${F}：“水陆两栖，有点意思。”`}</p>,
      <p className="note-content">我：“小鹤，你是独生子女吗？”</p>,
      <p className="note-content">小鹤：“我有个妹妹，比我小12岁，在上小学。”</p>,
      <p className="note-content">{`我：“${FULL}你呢？”`}</p>,
      <p className="note-content">{`${F}：“我有个弟弟，比我小10岁。”`}</p>,
      <p className="note-content">我：“我也有个弟弟！比我小9岁。我弟上大二了。你弟呢？”</p>,
      <p className="note-content">{`${F}：“他高三，在准备高考，天天晚上学到2、3点，白天又困的不行，一点效率都没有，跟他讲又不听。”`}</p>,
      <p className="note-content">我：“哦确实，这样不行，睡觉一定要保证足够。熬夜一点用都没有。我和我弟也聊不到一块去。”</p>,
      <p className="note-content">我：“话说，小鹤，你和你妹能聊到一起去吗？”</p>,
      <p className="note-content">小鹤：“啥意思？就平时聊一聊日常呗。她有事的时候找我。”</p>,
      <p className="note-content">{`${F}：“你说的这是作为哥哥的责任，应该做的。”`}</p>,
      <p className="note-content">{`我顺着${F}的话接下来：“你这是高维在低维的投影。我们说的能聊是指你会不会和你妹亲诉一些你的痛苦或者烦恼。”`}</p>,
      <p className="note-content">小鹤：“没有吧，感觉我也没有什么痛苦的事情好倾诉的。”</p>,

      <h3 className="post-heading">太子</h3>,
      <p className="note-content">饭店等上菜期间：</p>,
      <p className="note-content">小鹤：“姐，你在两个组待，你觉得Tobias组怎么样啊？”</p>,
      <p className="note-content">我：“我觉得Tobias他像个老爷爷一样，絮絮叨叨半天没个重点，Lyme相比于他一针见血。”</p>,
      <p className="note-content">{`${F}：“Lyme不喜欢‘蠢蠢’的本科生，喜欢聪明的。”`}</p>,
      <p className="note-content">“他不喜欢的就是我这样的hhh”，我自嘲道。</p>,
      <p className="note-content">他盯着我看了看，若有所思。</p>,
      <p className="note-content">我：“另外我觉得哈，教授的科研水平和教学意愿成反比。”</p>,
      <p className="note-content">{`${F}：“欸欸，别忘了你是来我们UCI访问的，注意你的言辞，不要破坏我们两个组的感情。”`}</p>,
      <p className="note-content">读懂了我的嘲讽，他用戏谑的语气微微点出了我的过于直接。</p>,
      <p className="note-content">我：“我觉得Lyme好喜欢你，而且我发现你是不是你们组唯一的男生！”</p>,
      <p className="note-content">{`联想到太阳的后裔，他们组的几个女生不就是拥抱${F}的月亮嘛？`}</p>,
      <p className="note-content">{`“我可是太子”，${F}刚还嘴角憋着笑，说完这句话一秒破功。`}</p>,
      <p className="note-content">“太子？！难道是有什么皇位要继承吗？” 我顺着他的话表演下去。</p>,
      <p className="note-content">{`难怪开组会时Lyme总是和他眉来眼去，不止是同类的心心相惜，${F}是他唯一的继承人啊！`}</p>,
      <p className="note-content">他眼睛眨巴眨巴，眼神有些闪烁。</p>,
      <p className="note-content">“那不是很好吗？” 小鹤显然对博士生态圈一无所知。</p>,
      <p className="note-content">{`“你以为这是什么好事吗？！” ${F}舔了舔嘴唇，上下眼皮快速翻动。他说话一快就这样，舌头紧掐节奏，而且从来不会和牙齿打架的那种。`}</p>,
      <p className="note-content">“Lyme的资源不都倾向于你吗？”，小鹤无辜的加问。</p>,
      <p className="note-content">“没人和你聊research，你觉得呢？” 他一反刚才的狡黠，无奈的反问。</p>,
      <p className="note-content">一瞬间，他华丽的面具裂开了个小口，我好像瞥见了他面具之下的忧愁和孤独。</p>,
      <p className="note-content">同是天涯沦落人，相逢何必曾相识。</p>,

      <h3 className="post-heading">冬神</h3>,
      <p className="note-content">{`虽然来鸡飞蛙跳是${F}一个人的主意，可🐸确实很好吃，稍微有点辣，呛的我咳嗽不止，小鹤也被辣的脸上挂满了汗珠，不过这正和我胃口。我和${F}都点了老北京酸奶，小鹤单独点了杯饮料，我们三个就这样吃一口蛙，喝一口饮料，天南海北的胡侃着。`}</p>,
      <p className="note-content">我：“你最近在看什么书？”</p>,
      <p className="note-content">{`${F}：“最近小红书上很火的《人妻约会指南》，清华姚班李新野写的。”`}</p>,
      <p className="note-content">“人妻约会指南？这是什么鬼？”，小鹤和我正被辣的狂喝水吃饭，差点没喷饭出来。</p>,
      <p className="note-content">我：“我就知道，你这个人看上去一本正经，玉树临风的，没那么简单，没想到私底下喜欢看这种乱七八糟的书！”，我对他的许多猜想像解数学证明题一样向着最后的推导成功迈进一步又一步。</p>,
      <p className="note-content">“都看看”，他突然害羞起来，还挺可爱的。</p>,
      <p className="note-content">{`${F}清清嗓，"现代社会大家压力都比较大，男性结婚性价比不高，要买房、付昂贵的彩礼之类的。相比之下找人妻约会更经济适用一些。这书以论文的形式论述了找人妻约会的优势还有配套的方针指南。"`}</p>,
      <p className="note-content">他娓娓道来，眼角眉梢也随之舒展开来。</p>,
      <p className="note-content">我：“这书具体讲什么的啊？”</p>,
      <p className="note-content">{`${F}：“网上有，你自己去看不就知道了。”`}</p>,
      <p className="note-content">我：“你能发给我吗？”</p>,
      <p className="note-content">{`${F}点点头说可以。`}</p>,
      <p className="note-content">我：“你们清北可真是出人才啊，北大有吴谢宇，宇神。。。”</p>,
      <p className="note-content">{`${F}：“我们还有韦神。”`}</p>,
      <p className="note-content">我：“韦什么来着？”</p>,
      <p className="note-content">{`${F}：“韦”`}</p>,
      <p className="note-content">小鹤：“姐，你看什么啊”</p>,
      <p className="note-content">我：“我什么都看，最近在看香农的传记。”</p>,
      <p className="note-content">小鹤：“哦～，香农是写信息论的那个大佬吗？”</p>,
      <p className="note-content">我：“是啊。”</p>,
      <p className="note-content">{`${F}这时轻飘飘来了句“冬神”，差点把我吓得魂飞魄散。`}</p>,
      <p className="note-content">“啥？人家叫我冬哥好嘛！” 我选择抖个机灵来掩盖我内心的惊喜与慌乱。</p>,
      <p className="note-content">“弟弟，你经常和父母聊天嘛？” 我岔开话题。</p>,
      <p className="note-content">“就一周打一次电话，跟爸妈报平安吧，和他们能聊的也不多。姐你呢？”</p>,
      <p className="note-content">“不怎么聊吧，太难受了。每次都是在重复同一个主题的两个不同层面，结婚和生孩子，干嘛把所有对未来的期待都放在我的个人问题上？太痛苦了，我和他们聊完要缓半天才能缓过来。”</p>,
      <p className="note-content">“你家这情况，确实有点…，你弟是gay，本来还能把希望寄托在你身上，没想到你也是…，你爸妈这是担心没有人来继承香火。”</p>,
      <p className="note-content">他伶牙俐齿，不仅看穿了我的烦恼，还替我爸妈说了“公道话”。远隔重洋的我爸妈要是在场的话，一定欣慰的想当场预定他作女婿。</p>,

      <h3 className="post-heading">回家</h3>,
      <p className="note-content">“酒”足饭饱之后：</p>,
      <p className="note-content">我：“小鹤弟，你就别付了哈，这顿算是我和你学长请你的散伙饭。”</p>,
      <p className="note-content">小鹤：“哦，好，谢谢姐和学长。”</p>,
      <p className="note-content">{`${FULL}看着我，点头示意没问题。`}</p>,
      <p className="note-content">我：“没事儿，应该的。”</p>,
      <p className="note-content">{`商量好之后，${FULL}招呼服务员结账，只见他利落潇洒的抬起右胳膊，右手竖起大拇指、无名指和中指，整个人在挺直的身板衬托下显的霸气十足。`}</p>,
      <p className="note-content">“多少钱来着？”</p>,
      <p className="note-content">我转身拿起挂在椅背上的夹克，从口袋的一堆现金里面掏出来几张递给他，“够吗？”</p>,
      <p className="note-content">“还差一点”，</p>,
      <p className="note-content">“够了。”</p>,
      <p className="note-content">回家路上：</p>,
      <p className="note-content">我：“小鹤，你坐前头吧，和你学长最后叙叙旧。”</p>,
      <p className="note-content">小鹤：“哎，好。”</p>,
      <p className="note-content">{`${F}：“学长，叙旧。。。”`}</p>,
      <p className="note-content">他显然没预料到我的这个提议，瞅了两眼突然坐到他旁边的小鹤。</p>,
      <p className="note-content">小鹤：“姐，你为什么会念这个博士啊？”</p>,
      <p className="note-content">{`我：“其实我也不知道，硕士毕业后工作了两年，实在不喜欢被计划好的每一天，像打卡似的，久了很无趣。做科研更适合我，虽然科研到现在处处碰壁。${FULL}你呢？”`}</p>,
      <p className="note-content">{`${F}：“我现在觉得我可能不是那么适合做科研。”`}</p>,
      <p className="note-content">我：“为什么？”</p>,
      <p className="note-content">{`${F}：“自己的个性可能更适合当医生，拿手术刀。”`}</p>,
      <p className="note-content">我：“可是医生这个职业是违反人的生理规律的，熬夜班实在太辛苦，我有任对象就是医生。”</p>,
      <p className="note-content">哪壶不开提哪壶，我真想拿胶带把自己嘴巴粘起来。</p>,
      <p className="note-content">小鹤：“是的，医生可累了，我妈医院里就属她的行政岗位最舒服。”</p>,
      <p className="note-content">送完小鹤之后，我从后座坐回副驾驶位置，车里只剩下我们俩。</p>,
      <p className="note-content">他说，“回家”</p>,
      <p className="note-content">我说，“好，回家！”</p>,
      <p className="note-content">还不忘加了一句，“回我家”。</p>,
      <p className="note-content">默契十足！</p>,
      <p className="note-content">车开到我家楼下，我礼貌性的邀请他上来坐会，他也礼貌性的回复“太晚了，不了吧。”</p>,
      <p className="note-content">“早点睡！”</p>,
      <p className="note-content">“我也感觉太晚了。谢谢你送我回家，你也是，早点睡！”</p>,
      <p className="note-content">等我上了楼，才听到他车子掉头的声音。</p>,
      <p className="note-content">我洗完澡躺在床上，脑子里思绪乱飞。</p>,
      <p className="note-content">“人妻约会指南”，“冬神”，“回家”，“好，回家。”</p>,
      <p className="note-content">我一遍又一遍的回味我们的对话，怀里的抱枕被我翻来覆去压扁又弹回原状。12月中，盖着薄薄的被子，我竟然流了一身的汗。</p>,
      <p className="note-content">{`不知道${F}那天晚上觉睡的如何。`}</p>,
      <hr />,
      <p className="note-content post-footer">本文为虚构小说，灵感来源于生活碎片。人物与情节均经过艺术加工，请勿对号入座。</p>,
    ],
  },
  {
    id: 'add-wechat',
    aliases: ['wechat'],
    date: '2026-07-20',
    tags: ['story'],
    title: '[Memory Snapshot #04] 我们加个微信吧',
    excerpt: '10月中旬的加州仍然有些燥热，许是有些水土不服，加州的阳光虽那样刺眼，但我的内心却阴霾密布。在经历了近一个月的的彻夜难眠之后，我萌生起了打道回府的想法。',
    content: [
      <p className="note-content">10月中旬的加州仍然有些燥热，许是有些水土不服，加州的阳光虽那样刺眼，但我的内心却阴霾密布。在经历了近一个月的的彻夜难眠之后，我萌生起了打道回府的想法。</p>,
      <p className="note-content">又是要来4楼办公室的一天，昨晚和Ash在学校健身房举重区练了两个小时的，高强度运动回去之后肌肉酸疼伴随着轻微抽筋，我在床上翻来覆去，试了所有放松神经的物理方法，到凌晨5点才勉强入睡。</p>,
      <p className="note-content">睡到11点钟，我不情愿的从床上爬起来，想起来下午有组会要参加，麻利的把自己收拾好，没来得及吃饭，直接去了学校。</p>,
      <p className="note-content">不管头脑多昏沉，有多不想参加组会，但一想到组会上能见到可爱美丽的雨栖，单纯耿直的Nico，搞笑又很有眼力见的Sam，身体还是做出了诚实的行动。</p>,
      <p className="note-content">午饭时间，办公室里的人大概都出去吃午饭了，只有我一个人，本来就很多闲置工位的办公室显得更空旷。没几分钟，Paul吃完饭从外面回办公室，跟他打招呼之后，发现坐在Paul旁边的隔壁组的同事跟在他后面一起进来了。</p>,
      <p className="note-content">和这个人我貌似只在刚来的时候简短自我介绍过，之后再无交集。</p>,
      <p className="note-content">{`我的hosting教授Tobias一再建议我加入隔壁Lyme组，对于我的项目他自知有心无力。作为博士committee一员，他最近刚听了Lyme组费蕍的一篇文章汇报，大力赞赏，他觉得在他们组我应该能找到合适的人discuss。`}</p>,
      <p className="note-content">{`“你是${FULL}对吗？我看了你的文章，我们能聊聊吗？”`}</p>,
      <p className="note-content">{`大概是因为没睡好，我头脑一时发热，向我斜对角的${FULL}发起了交流请求。`}</p>,
      <p className="note-content">他缓慢抬起头，视线朝我看来，刚回到座位的他，面对我突如其来的问候，有些不知所措。</p>,
      <p className="note-content">{`${F}: “嗯，可以，在哪里聊？”`}</p>,
      <p className="note-content">我：“我们可以去外面聊吗？办公室不是很方便。你知道哪里比较合适吗？”</p>,
      <p className="note-content">{`${F}: “6楼有个天台，平时没什么人。”`}</p>,
      <p className="note-content">我：“好，那我们就去那里吧。”</p>,
      <p className="note-content">电梯里我注意到他的白色连帽衫上印着明晃晃的三个字母，“你是ETH毕业的吗？”</p>,
      <p className="note-content">{`${F}: “嗯，在那念的硕士。”`}</p>,
      <p className="note-content">“我在LMU念的计算语言硕士！”，我有些激动。</p>,
      <p className="note-content">同在德语区硕士毕业，我开始有些懊悔为什么没有早点和他搭上话。</p>,
      <p className="note-content">我：“你是做大语言模型对齐研究的对吧，我看了你的论文，感觉我们的科研方向很相近。”</p>,
      <p className="note-content">来到6楼，天台上的桌椅摆放稀疏，我们俩随便找了张桌子，挨着坐了下来，两个人被遮阳伞的底座隔了开来。</p>,
      <p className="note-content">{`不知道我们从什么话题开始聊起，只记得我东扯西扯，从大语言模型扯到人类社会系统，语无伦次，毫无逻辑。${FULL}显然没能跟的上我极端跳跃的思维。`}</p>,
      <p className="note-content">我：“你的意思是模型预训练和微调阶段的投入比重应该是呈现金字塔形状的吗？”</p>,
      <p className="note-content">{`${F}: “感觉我们说的好像不是一个东西。”`}</p>,
      <p className="note-content">他眉毛微皱，眼睛快速的眨了几下，视线微微向我的方向瞥来，却在我俩视线即将交汇之际躲开了。</p>,
      <p className="note-content">我：“我们说的应该是一个东西，我只是思路比较混乱，那你觉得预训练阶段和下游微调它们是同等重要的吗？”</p>,
      <p className="note-content">{`${F}: “预训练和微调当然都很重要，但是它们的目标和作用是不一样的，不能混为一谈。”`}</p>,
      <p className="note-content">我：“嗯，当然，但是我们怎么利用预训练模型，减轻下游微调的压力这一块我感觉还做的不够。”</p>,
      <p className="note-content">{`${F}: “昂，我上一篇文章做的就是在推理端结合小模型将大模型对齐。”`}</p>,
      <p className="note-content">我：“我看了你的那篇文章，写的很好。我觉得我们的思路是很像的，都是觉得大语言模型自身能力没完全开发出来。”</p>,
      <p className="note-content">我：“对了，我现在在做的一个项目就是直接利用大语言模型本身的architecture特性进行推理端的对齐。”</p>,
      <p className="note-content">{`${F}: “什么意思？”`}</p>,
      <p className="note-content">我：“就是利用模型的自回归特性在模型推理的时候加suffix作为约束...，哎，我讲不清楚，我还是给你看ppt吧。”</p>,
      <p className="note-content">{`${F}: “哦，可以啊，那我们回办公室吧。”`}</p>,
      <p className="note-content">近1点，办公室陆续人多了起来。</p>,
      <p className="note-content">我：“对不起，我这个人temperature比较高，说话乱七八糟的。”</p>,
      <p className="note-content">{`${F}: “没事儿，temperature高说明你比较energetic嘛。”`}</p>,
      <p className="note-content">他表情轻松，语气淡定。</p>,
      <p className="note-content">{`没-事-儿，这三个字简简单单，事后无数次回想起来，它赋予了当时的我千钧之力。${FULL}像一束光，一瞬间点亮了我的生命，从此我的天空不再乌云密布。`}</p>,
      <p className="note-content">回到我座位上，“你等下，我找找我的ppt在哪里。”</p>,
      <p className="note-content">我：“诶，我怎么找不到canva了。”</p>,
      <p className="note-content">我：“哦，找到了。”</p>,
      <p className="note-content">{`接下来的几分钟，我对着自己上周在Tobias组会上讲的ppt跟${FULL}解释了起来这个项目。`}</p>,
      <p className="note-content">{`对于聪明的同行来说，言语的解释是冗余低效的，图示的信息密度胜过一切，${FULL}一看ppt里面的图就立刻抓住了idea的核心。`}</p>,
      <p className="note-content">{`${F}: “哦，你这个方法挺有意思的，之前应该没人做过，是个新方法。”`}</p>,
      <p className="note-content">我：“是的！但是我讲不清楚，所以好多人都get不到。你是第一个听懂这个idea的人。”</p>,
      <p className="note-content">{`${F}: “我觉得不怪你，对大部分人来说，新的idea没那么容易理解。你这个图可以稍微这样改一下，”`}</p>,
      <p className="note-content">说着他靠近白板，拿起笔开始画起图来。</p>,
      <p className="note-content">{`${F}: “我觉得这样会更清楚一些，大家能立马意识到这和挂一个classifier的区别在哪里。”`}</p>,
      <p className="note-content">我：“嗯嗯，天呐！太感谢你了！之前不仅没有人听懂并且还质疑这个idea，你是到目前为止唯一一个听懂了还给予它认可的人。我不知道要怎么表示我对你的感谢。”</p>,
      <p className="note-content">我：“你愿意当我的collaborator吗？”</p>,
      <p className="note-content">{`${F}: “这样吧，正好马上周末，我们都回去想一想，这个idea用在哪些具体任务上会更能体现它的效用。”`}</p>,
      <p className="note-content">我：“我们加个微信吧。”</p>,
      <p className="note-content">{`${F}: “好啊。”`}</p>,
      <p className="note-content">相识1个月，我们终于加上了微信。</p>,
      <p className="note-content">微信上：</p>,
      <p className="note-content">{`UCI-NLP-PhD 费渝`}</p>,
      <p className="note-content">HPI 王殷冬 </p>,
      <p className="note-content">也就在那一天，我的撤离计划还没开始就宣告搁浅。</p>,
      <hr />,
      <p className="note-content post-footer">本文为虚构小说，灵感来源于生活碎片。人物与情节均经过艺术加工，请勿对号入座。</p>,
    ],
  },
  {
    id: 'happy-birthday',
    aliases: ['happybirthdaytoyou'],
    date: '2026-06-09',
    tags: ['story'],
    title: '[Memory Snapshot #03] Happy Birthday!',
    excerpt: `我们短暂相遇却念念不忘，当天边那轮弯弯的月亮出现，你可知我又开始想念。亲爱的${F}，生日快乐！`,
    content: [
      <div className="note-poem">
        <p>我们短暂相遇却念念不忘，</p>
        <p>当天边那轮弯弯的月亮出现，</p>
        <p>你可知我又开始想念。</p>
        <p>有多少爱恋只能遥遥相望，</p>
        <p>如今我们已天各一方，</p>
        <p>冥冥中什么已改变，</p>
        <p>但愿你被温柔对待。</p>
        <p className="note-poem-dedication">{`亲爱的${F}，生日快乐！`}</p>
      </div>,
      <p className="note-content">{`“${FULL}，你在家吗？那个，办公室的门被锁了，我进不去。”我站在门口，深呼吸了几下，轻握起拳头连续敲了两下他家的门。`}</p>,
      <p className="note-content">{`“你知道我没有办公室的门卡，我问Suman借的卡，他是一个database组的博士后，我们是通过Ash在ARC练举重认识的。"我急向他解释我是怎么进的办公室，顺便澄清我和Suman的关系。`}</p>,
      <p className="note-content">{`“而且这一次我所有东西都落在里面了。我的书包，手机、电脑，还有我的ipad都在办公室里头。我身上只有一个apple watch，连的还是我在德国的手机，一点用也没有。“ 我继续陈述我的惨状。`}</p>,
      <p className="note-content">{`“你这人怎么回事，怎么一天天的老是和锁有问题。”他的声音急速从房间里蹦出来，隔着门板的我听到他略带怒气的往门口靠近。`}</p>,
      <p className="note-content">我舒了一口气，他在家，原本悬在门上的手就势放了下来。</p>,
      <p className="note-content">{`“我也不知道怎么回事，我就被锁在外面了。Suman把他的卡借给我，他来办公室我就得给他开门。”`}</p>,
      <p className="note-content">{`“我们一起坐电梯上来，闲聊，他说他没来过四楼，我说可以带他来参观一下。”`}</p>,
      <p className="note-content">{`“在办公室里我很激动的跟他讲，美国公立大学教授经费那么紧张，而学校办公室却闲置多年，大半座位都没人坐，这是极大的资源浪费。”`}</p>,
      <p className="note-content">{`“另外学校系统很fragile，门禁系统怎么可以允许办公室的卡能解锁学生宿舍的大门，这应该是两套相互独立的系统才对。”`}</p>,
      <p className="note-content">{`我一通输出，借着在办公室里和Suman的对话，把我这些天百思不解的困扰说给${FULL}听，连珠炮似的讲完才意识到自己不是来辩论的，是来求助的。`}</p>,
      <p className="note-content">{`“送他进电梯之后，我顺便上了个厕所，回到办公室门口，发现门居然锁上了。”`}</p>,
      <p className="note-content">{`“可能是着急出门，忘了拿那个纸箱把门隔起来。”被自己蠢哭，我也非常无奈。`}</p>,
      <p className="note-content">{`“抱歉，我并不想来打扰你。我一点也不想发生这些事，我也不知道为什么老是碰到这些事，我特别想知道为什么。我来这里的唯一目的是做科研，我只想把我自己那个开始了近一年的项目完成，除此之外我真的别无想法。”`}</p>,
      <p className="note-content">假如爱因斯坦是对的，我也想知道上帝为什么要让我一再经历此等荒谬绝伦的事情，逼我到无家可归、走投无路的地步。拿出120分的真诚，我开始对他吐露真心，这些天发生的事情太过戏剧性，但是它们根本并非我意，甚至完全不由我控制。</p>,
      <p className="note-content">{`“关于那天在你家的事，对不起，我不应该...在你不愿意的时候开你的门。”`}</p>,
      <p className="note-content">微信上跟他道过歉，在他家门口再亲口向他道歉一次，以表示我对自己的不当行为悔意深重。</p>,
      <p className="note-content">{`“我可以把我的钥匙借给你，但你要还给我。” 他语气缓和了下来，应答道。`}</p>,
      <p className="note-content">我长舒了一口气，我的示弱计策奏效了，他同意借我钥匙。门溜开了个缝，他把办公室门卡从缝里递给我，我刚接他递过来的卡，门就轻轻合上了。</p>,
      <p className="note-content">从办公室走到他家这15分钟，我反复排演过一番措辞——我不止是来道歉、来借钥匙的，我有很多话要想对他说。接过卡，我抬手，对着那扇刚合上的门，又敲了一下。</p>,
      <p className="note-content">{`“这场代号为海底捞鱼的游戏game over了。”`}</p>,
      <p className="note-content">{`“我宣布你这个机敏细腻的北大才子赢了。”`}</p>,
      <p className="note-content">{`“不管你是研究力学的费曼的学弟，还是唱歌的费玉清和费翔的关门弟子，或者是做大语言模型研究的费家‘太子’，这场游戏你赢了。”`}</p>,
      <p className="note-content">{`“我主动缴械投降，你大获全胜。”`}</p>,
      <p className="note-content">门没有开。里面一点声音也没有。</p>,
      <p className="note-content">我对着那扇门，把我憋了很久的话讲完了。</p>,
      <p className="note-content">我站在合上的门前，没动。我转身要走，又顿住。</p>,
      <p className="note-content">{`“那个你能不能把你的scooter也借我一下，从你家走到DBH要15分钟，来回就是半个小时，骑scooter的话只要10分钟不到。”`}</p>,
      <p className="note-content">{`“行，你等下”`}，利落干脆。</p>,
      <p className="note-content">门大开，他把scooter推出来，身上裹着厚厚的居家棉服，眼眶上架着他平时在办公室戴的防蓝光眼镜，镜框设计类似于运动眼镜，紧紧贴合眼眶骨。我连忙上前握住车把，低头的瞬间发现小猫咪躲在他身后，正偷偷地看着我。没作停顿，道谢之后快速骑上scooter离开他家所在的宿舍区域。</p>,
      <p className="note-content">{`大约15分钟之后，我回到他家，“${FULL}，我回来了，你开下门。”`}</p>,
      <p className="note-content">{`他把门大开，”你把睡袋也拿过来了！“，没想到我不仅是回办公室拿卡，也是来归还他借给我的东西。`}</p>,
      <p className="note-content">他接住我递给他的睡袋，我推着scooter上前，跨过门框进了他家。15分钟的时间他仿佛换了个人。眼镜不见了，露出来刚刚被遮住的大眼睛，神采熠熠。身上换了件和我衣服颜色相近的森林绿抓绒外套，是patagonia的。裤子换了条黑色牛仔裤，不知道是不是我穿的李维斯的男款。小猫咪则静坐在他左手边，尾巴乖巧的贴在地上，呆呆的盯着我看。</p>,
      <p className="note-content">一人一猫精心梳洗打扮了一番，整整齐齐的站在我面前，像是在迎接我的归来。</p>,
      <p className="note-content">{`我一时没反应过来，有些错愕，朝他们多看了两眼，${F}微微侧过身，眼神闪躲开。`}</p>,
      <hr />,
      <p className="note-content post-footer">本文为虚构小说，灵感来源于生活碎片。人物与情节均经过艺术加工，请勿对号入座。</p>,
    ],
  },
  {
    id: 'yuichliebedichduschlampe',
    date: '2026-06-01',
    tags: ['story'],
    title: '[Memory Snapshot #02] yuichliebedichduschlampe',
    excerpt: '“你能不能别转笔了！好吵！还有抖腿，不要抖了！”隔着墙我都能听到他转笔掉的声音，我疾步冲到他面前，愤怒的对他吼道。',
    content: [
      <h3 className="post-heading">香水是不是你喷的？</h3>,
      <p className="note-content">{`“你能不能别转笔了！好吵！还有抖腿，不要抖了！”隔着墙我都能听到他转笔掉的声音，我疾步冲到他面前，愤怒的对他吼道。`}</p>,
      <p className="note-content">{`“香水是不是你喷的？” 吼完立马开始质问他。`}</p>,
      <p className="note-content">{`“不是我，你怎么知道是我？” 他迅速回击，眼睛却直盯着电脑屏幕，手里的笔还在继续转着，一直抖着的腿倒是消停了下来。`}</p>,
      <p className="note-content">{`“不是你还是谁？”，他毫无认错意识，这更激起了我的怒火。`}</p>,
      <p className="note-content">{`“这么多人在办公室里办公，你喷这么浓的香水，你让别人怎么工作？你看看，他们是不是都被呛走了？你刚也一直在打喷嚏是不是？”，但我知道光有情绪不够，还得跟他讲理。`}</p>,
      <p className="note-content">{`“我没有，我才刚打一个喷嚏！” 他连忙否认，像个被大人抓包做错事的小孩，语气委屈巴巴的。`}</p>,
      <p className="note-content">{`“蛋糕是给我准备的，对吗？”`}</p>,
      <p className="note-content">{`我拿起沙发上的蛋糕大口往嘴里吞，三两下就吃完了，“咖啡味的，还挺好吃的，谢谢哈，你满意了吗？”`}</p>,
      <p className="note-content">{`“说！你到底想干嘛？” 办公室只有我们二人，干脆把所有事情都说清楚。`}</p>,
      <p className="note-content">{`“Please leave me alone! I have an interview in half an hour.”`}</p>,
      <p className="note-content">他情绪激动起来开始飙英语，上半身僵直坐在电脑前，眼睛仍旧盯着屏幕，故意回避和我对视，右手转着的笔一个没控制好，飞了出去。霎时间，他从脖子到耳朵根再到脸唰的一下涨红了起来，白色的圆领衫衬的脖子还有耳朵格外的红。</p>,
      <p className="note-content">我见过人吵架闹的脸红脖子粗的，动手动脚的也不在少数，可是像他这般表情、言语还有肢体传达信息如此割裂的我是头一回碰见，我愣住了，也意识到不能再继续逼他了。我扫了下周围，这么大的办公室里，刚被香水呛出去透气的同事随时会回来。我顺着他的眼神往屏幕看了过去，一张宽大的4k显示器上只孤零零的显示着他的简历，鼠标停留在简历最上方一行，他的名字那样醒目。我一时间有些出神，心中不解，难道他过去几小时鼠标连动都没动吗？这样想着，再看他侧脸潮红一丝未退去，我的怒气瞬时消散，心下一软，转身默默离开了他的工位。</p>,
      <p className="note-content">{`回到隔壁的座位上，打开电脑想继续工作一会，却始终无法集中注意力。我心乱如麻，不知道该做些什么才好，开始回想刚发生的这一切。不管${F}表面多强装镇定，他越说没有，那片红越往上爬，从脖子一直烧到耳根。他爱我？但是在办公室里喷满我前两天用过的香水，这是为什么？他不想别人闻到我的味道吗？他平日里的冷静克制去了哪？我实在想不明白为什么要在大庭广众之下做出来这样子不够体面的事情。我一面生气不解，一面强行让自己大脑静下来分析他的行为动机，试图从他荒唐的行为里解读他真实的想法。`}</p>,
      <p className="note-content">{`我要怎么安抚他？第一次面对这样来势汹涌的——爱意？我无所适从，为数不多的恋爱经验里没有记录过这么一出，我要怎么办？我就这样静静的坐在座位上呆看着电脑屏，过了一会，想着他该缓过来了，继续思考怎么安抚他才好。`}</p>,
      <p className="note-content">{`办公桌上有只绿色的笔，是我很多天前从他位置拿来的，我学着他拿笔转了起来。笔转到桌角，我扫了眼桌角，发现了便利贴，顺手用德语写下“yuichliebedichduschlampe”，写完对着仔细看了看，${F}不懂德语，但是在苏黎世念的硕士，怎么着应该学过一丢丢，前段时间还在跟我秀小舌音。喜欢玩侦探类冒险游戏的他肯定会去查这什么意思。收拾完书包起身走到他座位旁，看到他还在盯着屏幕看，暗暗想他interview要开始了吗，往外张望看有没有同事进来，暂时没有。我把纸条翻了个面，轻轻从桌子一角递给他，没等他做反应，我就背起书包，转身离开了办公室，当然没忘扫他的屏幕，仍然停留在他的简历第一行那里。`}</p>,
      <hr />,
      <p className="note-content post-footer">本文为虚构小说，灵感来源于生活碎片。人物与情节均经过艺术加工，请勿对号入座。</p>,
    ],
  },
  // {
  //   id: 'paper-review-system',
  //   date: '2026-05-11',
  //   title: 'On the current paper review system in Deep Learning',
  //   content: [
  //     'I"ve been thinking about this for a quite long time. The problems we encounter are central to one single core problem: too many papers get assigned to too few reviewers. ' +
  //       'Since I"ve joined HPI as a PhD student, when we talk about the paper submission and review process, we mostly got this complaints from both PhD and professors. ',
  //   ],
  // },
  {
    id: 'disentangle',
    date: '2026-05-06',
    tags: ['note'],
    title: 'Disentangle one thing from another',
    excerpt:
      'I enjoy solving real-life problems, regardless of their complexity, as long as they challenge me. That being said, I am someone who constantly observes problems while also harboring many of my own, which keeps my mind continuously racing.',
    content: [
      <h3 className="post-heading">1. The Stagnation of Research</h3>,
      <p className="note-content">I enjoy solving real-life problems, regardless of their complexity, as long as they challenge me. That being said, I am someone who constantly observes problems while also harboring many of my own, which keeps my mind continuously racing.</p>,
      <p className="note-content">I cannot stop thinking about research because I see so many unresolved issues. I read papers for two purposes: to gain knowledge and to seek problems. Yet, I get bored quickly{'\u2014'}especially when a research field stagnates, getting stuck on a single point and merely recycling the same approaches with different phrasing.</p>,
      <ul className="post-list">
        <li><strong>Was the problem actually solved?</strong></li>
        <li><strong>Or was it even a new problem to begin with?</strong> Probably not. History repeats itself.</li>
      </ul>,

      <h3 className="post-heading">2. The Observer's Prior</h3>,
      <p className="note-content">At this point, studying people within a societal environment and its derived complexity makes me feel more alive, giving my existence a sense of meaning.</p>,
      <p className="note-content">From an observer{'\u2019'}s perspective, it is impossible to observe without one{'\u2019'}s own purposes and biases. This is what we call <em>the prior</em>. Whether or not we consciously use this prior, we are inherently involved, simply because <strong>observation is inextricably entangled with action.</strong> We must decide what actions to execute to steer things in the direction we desire.</p>,

      <h3 className="post-heading">3. The Dilemma of Choice</h3>,
      <p className="note-content">The first step is to distinguish between what we can and cannot do, conditioned on our environment. Depending on our interaction with the subject and the timing, we are left with either many options or none at all. Does having many options mean we are lucky? I don{'\u2019'}t know. But certainly, having no options is rarely ideal.</p>,
      <p className="note-content">When we do have choices, we are forced to ask:</p>,
      <ul className="post-list">
        <li>What should we choose?</li>
        <li>Why not the alternatives?</li>
        <li>And what are the consequences of taking one path over another?</li>
      </ul>,
      <p className="note-content">The most crucial question becomes: <strong>can we accept those consequences?</strong></p>,

      <h3 className="post-heading">4. Untangling the Knots</h3>,
      <p className="note-content">Thinking about this gives me a headache. I consulted Ralf<a href="#fn-ralf" id="fnref-ralf" className="footnote-ref"><sup>1</sup></a> about what I should do. The people involved are entangled with one another, and everything about them is intertwined. I like good entanglements, not bad ones. However, I don{'\u2019'}t know how to transform a bad entanglement into a good one.</p>,
      <p className="note-content">Ralf suggested we should <strong>disentangle the situation by removing the unnecessary knots</strong>, and then untangle whatever remains. By starting at the exact point where the entanglement turned bad, the situation becomes much clearer.</p>,
      <p className="note-content">I simply don{'\u2019'}t want to walk away from the entanglement, even though it is so messy. Or perhaps I am just afraid of the negative consequences my actions might bring. We could rely on trial and error.</p>,
      {
        quote:
          '\u201CUncertainty is only diminished when we persist to the very end. Sometimes, we must simply act without overanalyzing. Disentangle action from overthinking! Embrace the uncertainty, and accept that the outcome might be unfavorable. That is simply what life is.\u201D',
      },
      <p className="note-content">said Ralf. Maybe we should just trust our intuitions and follow our hearts.</p>,
      <p className="note-content">Dear reader, can we? Or perhaps we should reverse the question and instead ask: <strong>why can{'\u2019'}t we?</strong></p>,

      <hr className="footnotes-divider" />,
      <ol className="footnotes-list">
        <li id="fn-ralf">
          <a href="https://herbrich.me/" target="_blank" rel="noopener noreferrer">Ralf</a> is my second PhD supervisor. <a href="#fnref-ralf" className="footnote-back" aria-label="back to text">
            <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <polyline points="9,4 4,8 9,12" />
              <path d="M4 8h7a3 3 0 0 1 3 3v1" />
            </svg>
          </a>
        </li>
      </ol>,
    ],
  },
  {
    id: 'david-tao-concert',
    date: '2026-05-26',
    tags: ['story'],
    title: '[Memory Snapshot #01] 陶喆演唱会',
    excerpt: `临近演唱会，${F}为了让我熟悉陶喆的歌，特意下载了歌单，speaker从早到晚循环往复的播放陶喆的歌……`,
    content: [
      <h3 className="post-heading">出门</h3>,
      <p className="note-content">{`临近演唱会，${F}为了让我熟悉陶喆的歌，特意下载了歌单，speaker从早到晚循环往复的播放陶喆的歌。温馨的两人宿舍里，R&B的调调混合陶氏情歌略有些轻浮的歌词，一股暧昧的情愫在狭窄的空间里弥漫开来。`}</p>,

      <p className="note-content">昨晚睡的还不错，早上起来神清气爽的，我坐在餐桌前想起来今天是去看演唱会的日子。</p>,
      <p className="note-content">{`“演唱会几点开始啊？我们几点出发？”，我出游一向不喜欢做计划，演唱会又是${FULL}邀请的，他安排计划好一切，我乐得省心，只是跟他确定下自己大概几点要收拾打扮好。`}</p>,
      <p className="note-content">{`“8点吧，我们大概下午4点15出发，群里那几个朋友都会一起。”${F}看了看手机简单回复道，顺手摸了把趴在桌上，尾巴一摇一摆的小猫咪。`}</p>,
      <p className="note-content">“好的”。“你演唱会穿什么？我觉得我好像没什么衣服穿。”我突然想起上次去看演唱会的囧况，也是在LA，大概只有我一个人穿着sweater和牛仔裤，没有任何装扮，在其他精心打扮的粉丝中间显得格格不入。</p>,
      <p className="note-content">{`“不用穿什么特别的，你平时穿的就行。”${F}似乎是察觉到了我的一丝紧张情绪，语气淡定的安抚我，随后两手一伸把小猫咪整个从桌上抱了起来，踱回他房间。`}</p>,

      <p className="note-content">我没信他的话，可还是犯起了难，自己确实没有什么衣服穿，而且因为是借住在他家，衣服都被整理在宜家的大袋子里面，拿出拿进的不是很方便。下午随便挑了件自己平时穿的深灰色羊毛衫，鸡心领露能露出我漂亮的锁骨，款式修身，不管怎么样，要比松松垮垮的套头卫衣看上去像个正经人。我特意画了妆，头发稍稍整理了一下。最后在镜子前看自己，觉得这样打扮一下还算不错，能出门见人。</p>,
      <p className="note-content">就在我大概已经准备好，他不急不慢的在房间里开始换衣服，没要几分钟就出来了。上半身是他常穿的飞行员外套，里面还是白色的圆领衫，下半身一条深灰色裤子，搭配上英伦风的森林绿麂皮马丁靴，休闲又不失精致，而且配色很悦目。</p>,

      <p className="note-content">“好了吗，我们要走了，要先去接朋友。”他问我。</p>,
      <p className="note-content">“我需要带什么吗？手机，钱包，还有什么要带的吗”我着急慌忙的跟他确认自己是不是带了需要的东西。我出门总是到半路上才想起来有些东西没带，糊涂蛋丢三落四的属性估计这辈子也改不掉了。。。</p>,
      <p className="note-content">“带上个充电宝吧，其他没什么要带的了。”</p>,
      <p className="note-content">“确定没其他的要带的了吗？护照要带吗？我上次去LA clubbing，没带护照，人家不给我进。”我出门焦虑，最后再跟他确认一次。</p>,
      <p className="note-content">“看演唱会要什么护照，没有了，可以走了吗？”他手里攥着车钥匙，语气显的略有些不耐烦。我见状快速和小猫咪说了拜拜之后，跟在他后面，一起出了门。</p>,

      <h3 className="post-heading">我们俩能换个位置吗 [TODO]</h3>,

      <h3 className="post-heading">PPT梗 [TODO]</h3>,
      <p className="note-content">剧透</p>,
      <p className="note-content">{`${F}：“可是我PPT做的没那么好”`}</p>,
      <p className="note-content">我：“PPT做的好的人都很油腻。”</p>,

      <h3 className="post-heading">回“家”</h3>,
      <p className="note-content">{`从LA上高架之后我们的车就一路狂飙，手握方向盘的${F}油门加的丝滑，刹车踩的轻盈无比，转弯时方向盘控制的力度刚刚好，让人有种轻微的失重和眩晕感，坐在副驾的我体验到了一种难以名状的“爽”感。`}</p>,
      <p className="note-content">{`LA回尔湾的路上好多高架弯道，蜿蜒起伏的，加上地广人稀，路都修的宽阔，欧洲几乎见不到的8车道对加州司机来说可以说是司空见惯，但这对司机是个考验，一个不注意就可能下错了道，再转回来需要费点功夫。所以通常坐副驾的人除了陪司机聊天之外，还承担了一个比较重要的责任，那就是navigation。路痴加上不会开车的我一点也指望不上，但还是象征性的拿出手机开着google导航，一面注意路牌，一面仔细看地图，生怕自己弄错，让大家回不了家。大概半小时过后，我提着的心慢慢放松了下来，因为发现我的导航完全就是多余的，${F}他多线程操作，开车、导航、听音乐、同时还能在我们聊天中时不时的像个老干部似的插入一两句重点。驾驶员一脑多用，处理的还都是极端复杂的开放性任务，这计算效率alphago能与之相提并论吗？`}</p>,

      <p className="note-content">在加州，城市内公共交通几乎约等于无，出门只有开车或者uber，像我这样来短期访问的博士生压根不会去想买车这件事，加上没有驾照，就只能call uber。好在我刚来不久就和大家打成一片，所以经常有同事的车蹭坐。那段时间坐了好多不同的车，司机有男有女，除了和同事们一起吐槽加州司机很危险之外，倒是没什么特别的感觉。</p>,
      <p className="note-content">{`${F}开车让人上瘾，恰到好处的刺激，加上掐准时机的停顿，这“车”开的很老司机。如果没有接受过专业训练的话，天赋异禀！`}</p>,

      <p className="note-content">{`一路上我夸他就没停下来过，是发自内心的赞许！yr也跟着附和，我们两个一唱一和给${FULL}夸上天，我偶尔用眼角余光瞥了瞥他，他嘴角若有若无的上扬，平日里一张拒人于千里之外的冰山脸在今天难得现出了寻常人一样的喜悦表情。`}</p>,

      <p className="note-content">热火朝天的聊了一整路，快到尔湾时，已经是凌晨1点半了，大家都疲惫不堪，车里渐渐安静了下来，只剩下陶喆的歌还在一缕一缕的回放着。</p>,

      <p className="note-content">“我好饿啊”，我肚子咕咕地叫了几声，我吸了吸肚皮，独自咕哝了起来。</p>,
      <p className="note-content">{`“对哦，你今晚都没怎么吃，让${F}哥回家给你做！”坐在后排的yr很知趣的接上我的话，说话间上身从座位上直立了起来，朝前排微微倾斜。`}</p>,
      <p className="note-content">{`“家里有什么吃的吗？”我转过头朝正在注视前方，认真开车的${F}看去，内心有些许期待，没等回复，又自顾自的回答“我可以吃点零食，薯片还是有的”。`}</p>,
      <p className="note-content">{`“冰箱里有面包，你将就着吃点吧”${F}继续目视前方，不紧不慢的说。`}</p>,

      <p className="note-content">{`把yr和hz送回家之后，车里就只剩下我俩，没几分钟就到${F}住的宿舍区。把车停好之后，我们走路回“家”的路上，在一栋宿舍楼前碰见一个女孩，穿着短裙，站在马路边上像是在等人或者是uber。时值12月底，加州虽然没有冬天，但还是需要穿毛衣或者厚外套来抵挡10几度气温带来的寒气。凌晨2点左右，女孩独自一人身穿单薄衣服站在马路边，吸引到了我俩的注意。`}</p>,

      <p className="note-content">{`“这么晚一个人在外面，肯定不是什么好东西。” 我们过马路之后，${F}贱兮兮的揶揄道。`}</p>,
      <p className="note-content">“你说什么呢？我们俩不是也这么晚还在外面吗？” 我为女孩愤愤不平，有些愠怒。</p>,
      <p className="note-content">“我们俩也不是什么好东西……”他诨话一说好像就停不下来，居然说我也不是什么好东西，我一下子怒火中烧，抬起手就朝他的后背挥了过去。他自知无理，没敢还口。</p>,

      <p className="note-content">说话间就到家了，我们商量着他先去洗澡，我后面洗，我实在饿的不行，从冰箱里拿了几片面包开啃了起来。等我洗完澡，收拾好一切准备睡觉，已经快到3点，我上床一沾枕头就沉沉睡去了。</p>,

      <hr />,
      <p className="note-content post-footer">本文为虚构小说，灵感来源于生活碎片。人物与情节均经过艺术加工，请勿对号入座。</p>,
    ],
  },
  {
    id: 'launch',
    date: '2024-10-10',
    tags: ['note'],
    content:
      "Excited to launch my personal website! Started in 2022, " +
      "but put it on hold for 2 years, and now it's finally done.",
  },
];

export const notes = [...rawNotes].sort((a, b) => new Date(b.date) - new Date(a.date));

export const findNote = (id) =>
  notes.find((n) => n.id === id || (n.aliases && n.aliases.includes(id)));
